module.exports = __webpack_public_path__ + "img/eprice-red-round-01.586df428.png";